import React, { useEffect, useState } from "react";
import { INDUSTRY } from "../../../core/theme/auditsTheme";

// The industry tabs (up to 3, each with its Snapshot count), "More ▾" for the
// rest, and New search on the right. Picking from More swaps that industry
// into the last tab (industryTabs in core/data/auditsPage.js).
//   tabs, more: industry keys   byKey: key -> { name, snapshots }
export default function IndustryBar({ tabs, more, byKey, selected, onPick, onNewScan }) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = e => { if (e.key === "Escape") setOpen(false); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open]);

  const pick = key => { setOpen(false); onPick(key); };

  return (
    <nav aria-label="Industries" className={INDUSTRY.bar}>
      <div className={INDUSTRY.tabs}>
        {tabs.map(key => (
          <button
            key={key} type="button" onClick={() => pick(key)} aria-current={key === selected ? "page" : undefined}
            className={key === selected ? INDUSTRY.tabActive : INDUSTRY.tab}
          >
            {byKey.get(key).name}
            <span className={INDUSTRY.tabCount}>{byKey.get(key).snapshots}</span>
          </button>
        ))}
        {more.length > 0 && (
          <div className="relative flex">
            <button type="button" onClick={() => setOpen(o => !o)} className={INDUSTRY.more} aria-haspopup="menu" aria-expanded={open}>More ▾</button>
            {open && (
              <>
                <div className="fixed inset-0 z-10" onClick={() => setOpen(false)} />
                <div className={INDUSTRY.moreMenu} role="menu">
                  {more.map(key => (
                    <button key={key} type="button" role="menuitem" onClick={() => pick(key)} className={INDUSTRY.moreItem}>
                      <span>{byKey.get(key).name}</span>
                      <span className={INDUSTRY.moreCount}>{byKey.get(key).snapshots}</span>
                    </button>
                  ))}
                </div>
              </>
            )}
          </div>
        )}
      </div>
      <button type="button" onClick={onNewScan} className={INDUSTRY.start}>New Search</button>
    </nav>
  );
}
